import Icon from '../components/Icon'

Icon.register({
  users: {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M96 224c-35.3 0-64-28.7-64-64s28.7-64 64-64 64 28.7 64 64-28.7 64-64 64zM544 224c-35.3 0-64-28.7-64-64s28.7-64 64-64 64 28.7 64 64-28.7 64-64 64zM576 256c35.3 0 64 28.7 64 64v32c0 17.7-14.3 32-32 32h-66c-6.2-47.4-34.8-87.3-75.1-109.4 11.6-11.5 27.5-18.6 45.1-18.6h64zM320 256c-61.9 0-112-50.1-112-112s50.1-112 112-112 112 50.1 112 112-50.1 112-112 112zM396.8 288c63.6 0 115.2 51.6 115.2 115.2v28.8c0 26.5-21.5 48-48 48h-288c-26.5 0-48-21.5-48-48v-28.8c0-63.6 51.6-115.2 115.2-115.2h8.3c20.9 10 43.9 16 68.5 16s47.7-6 68.5-16h8.3zM173.1 274.6c-40.3 22.1-68.9 62-75.2 109.4h-65.9c-17.7 0-32-14.3-32-32v-32c0-35.3 28.7-64 64-64h64c17.6 0 33.5 7.1 45.1 18.6z'
      }
    ]
  }
})
